const cultureCodes = {
  danish: "da-DK",
  english: "en-GB",
  finnish: "fi-FI",
  norwegian: "nb-NO",
  swedish: "sv-SE",
  swedishFinland: "sv-FI",
};

export default cultureCodes;
